import { api } from "./api";

export const practiceApi = api.injectEndpoints({
    endpoints:(builder)=>({
        getTestResults:builder.query<any,void>({
            query:()=>({
                url:"/Practice/TestResults",
                method:"GET",
                // headers:{
                //     Authorization: `Bearer ${process.env.REACT_APP_API_TOKEN}`
                // }
            }),
            providesTags: ["Practice"]
        }),
        getPracticeTests:builder.query<any,void>({
            query:()=>({
                url:"/Practice/PracticeTests",
                method:"GET",
                // headers:{
                //     Authorization: `Bearer ${process.env.REACT_APP_API_TOKEN}`
                // }
            }),
            providesTags: ["Practice"]
        }),
    })
})

export const {
    useGetTestResultsQuery,
    useGetPracticeTestsQuery
} = practiceApi;